import React from 'react'
import { LandingPageImport } from '../Import'
const { GitCommitHorizontal, Slider, TextAnimate, organizer_img_1, organizer_img_2, organizer_img_3, organizer_img_4, organizer_img_5, organizer_img_6, organizer_img_7, organizer_img_8 } = LandingPageImport

export default function Organizer() {

    var settings = {
        arrows: false,
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000,
    };

    return (
        <>
            <div className="organizer">
                <div className="container">
                    <div className="row">

                        <div className="col-lg-12 m-auto">
                            <div className='hero_title text-center'>
                                <h5 data-aos="fade-left" data-aos-duration="800">
                                    <GitCommitHorizontal className='ms-1 me-1' />
                                    JOIN 4,000+ COMPANIES ALREADY GROWING
                                </h5>
                            </div>

                            <div className="hero_sub_title text-center">
                                <h2><TextAnimate text="Our Organizer" /></h2>
                            </div>
                        </div>

                        <div className="col-lg-12">
                            <div className="mt-5">

                                <Slider {...settings}>
                                    <div className="brand-box">
                                        <img src={organizer_img_1} alt="img1" />
                                    </div>
                                    <div className="brand-box">
                                        <img src={organizer_img_2} alt="img2" />
                                    </div>
                                    <div className="brand-box">
                                        <img src={organizer_img_3} alt="img3" />
                                    </div>
                                    <div className="brand-box">
                                        <img src={organizer_img_4} alt="img4" />
                                    </div>
                                    <div className="brand-box">
                                        <img src={organizer_img_5} alt="img5" />
                                    </div>
                                    <div className="brand-box">
                                        <img src={organizer_img_6} alt="img6" />
                                    </div>
                                    <div className="brand-box">
                                        <img src={organizer_img_7} alt="img7" />
                                    </div>
                                    <div className="brand-box">
                                        <img src={organizer_img_8} alt="img8" />
                                    </div>
                                </Slider>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
